import { render, staticRenderFns } from "./UpgradePopup.vue?vue&type=template&id=58dd7dc6&scoped=true"
import script from "./UpgradePopup.vue?vue&type=script&lang=js"
export * from "./UpgradePopup.vue?vue&type=script&lang=js"
import style0 from "./UpgradePopup.vue?vue&type=style&index=0&id=58dd7dc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dd7dc6",
  null
  
)

export default component.exports